export default "__VITE_ASSET__C$RomjiY__"